'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global __DEVTOOLS__ */


exports.default = configureStore;

var _redux = require('redux');

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxPromise = require('redux-promise');

var _reduxPromise2 = _interopRequireDefault(_reduxPromise);

var _nuiShell = require('@concur/nui-shell');

var _rootReducer = require('./rootReducer');

var _rootReducer2 = _interopRequireDefault(_rootReducer);

var _utils = require('../utils');

var _DevTools = require('./DevTools');

var _DevTools2 = _interopRequireDefault(_DevTools);

var _analytics = require('../analytics/analytics');

var _analytics2 = _interopRequireDefault(_analytics);

var _listingModule = require('../listing/listingModule');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function getDebugSessionKey() {
  // By default we try to read the key from ?debug_session=<key> in the address bar
  var matches = window.location.href.match(/[?&]debug_session=([^&]+)\b/);
  return matches && matches.length > 0 ? matches[1] : null;
}

var store = null;

function configureStore(initialState) {
  var req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var utilityFns = arguments[2];

  if (!initialState.userPrefs.userId) {
    initialState.userPrefs = _extends({}, initialState.userPrefs, {
      userId: ''
    });
  }

  var createStoreWithMiddleware = void 0;

  var customReduxMiddleware = _nuiShell.nuiReduxMiddlewares.customize({
    analytics: function analytics(mw) {
      return mw.withOptions({ mapStateToAnalytics: _analytics2.default });
    }
  });

  if (process.env.NODE_ENV !== 'production' && _utils.isClient && typeof __DEVTOOLS__ !== 'undefined' && __DEVTOOLS__) {
    var createLogger = require('redux-logger');

    var _require = require('redux-devtools'),
        persistState = _require.persistState;

    if (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
      createStoreWithMiddleware = composeEnhancers(_redux.applyMiddleware.apply(undefined, [_reduxThunk2.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise2.default, createLogger({
        level: 'info',
        collapsed: true
      })])), persistState(getDebugSessionKey()))(_redux.createStore);
    } else {
      createStoreWithMiddleware = (0, _redux.compose)(_redux.applyMiddleware.apply(undefined, [_reduxThunk2.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise2.default, createLogger({
        level: 'info',
        collapsed: true
      })])), _DevTools2.default.instrument(), persistState(getDebugSessionKey()))(_redux.createStore);
    }
  } else if (process.env.QA_REDUX_LOGGING) {
    var _createLogger = require('redux-logger');
    createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, [_reduxThunk2.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise2.default, _createLogger({
      level: 'info',
      collapsed: true
    })]))(_redux.createStore);
  } else {
    createStoreWithMiddleware = _redux.applyMiddleware.apply(undefined, [_reduxThunk2.default].concat(_toConsumableArray(customReduxMiddleware), [_reduxPromise2.default]))(_redux.createStore);
  }

  if (!_utils.isClient) {
    // this only works with webpack because of the Ignore plugin in config
    var ConcurProtect = require('@concur/concur-protect');

    // TripIt expects to decode using `_protectKey` from session
    // ConcurProtect knowns to grab this field and use it if present
    var otProtectCSRF = new ConcurProtect(req.session);
    var encryptUserId = utilityFns.encryptUserId;


    if (req.session && req.session.UserID) {
      initialState.userPrefs = _extends({}, initialState.userPrefs, {
        userId: encryptUserId(req.session.UserID),
        csrf_token: otProtectCSRF.protectValue('csrf_token', req.session.SessionId)
      });
    }
    var originalhost = req.headers['original-host'] || '';
    initialState.meta = _extends({}, initialState.meta, { originalhost: originalhost, listingNotFound: req.listingNotFound });
    initialState.baseUrl = (0, _utils.getNuiBaseUrlFromHost)(originalhost);
  }

  if (req.data) {
    initialState.listing = _extends({}, _listingModule.initialState, _defineProperty({}, req.listingId, {
      readyState: _listingModule.LISTING_FETCHED,
      data: req.data
    }));
  }

  if (req.location) {
    initialState.listing = _extends({}, initialState.listing, {
      localizedRegions: req.location.localizedRegions,
      localizedCountries: req.location.localizedCountries
    });
  }

  if (req.userProfile) {
    initialState.userProfile = req.userProfile;
  }

  store = createStoreWithMiddleware(_rootReducer2.default, initialState);
  return store;
}


//////////////////
// WEBPACK FOOTER
// ./lib/app/configureStore.js
// module id = 411
// module chunks = 0